import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import { task } from 'ember-concurrency'
import { eq } from 'ember-truth-helpers'
import type { IntlService } from 'ember-intl'
import type Store from '@ember-data/store'
import type FlashQueueService from 'teacher-ui-client/services/flash-queue'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import type RouterService from '@ember/routing/router-service'
import type SubscriptionUtilisationService from 'teacher-ui-client/services/subscription-utilisation'
import type { Log } from '@blakeelearning/log'
import type { LogArgument } from 'rollbar'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { PageAccessMissingReading } from 'teacher-ui-client/components/page/access-missing/reading'
import { PageAccessMissingMaths } from 'teacher-ui-client/components/page/access-missing/maths'
import { PageAccessMissingWriting } from 'teacher-ui-client/components/page/access-missing/writing'
import type TeacherSubscription from 'teacher-ui-client/models/teacher-subscription'

export class AccessMissing extends Component<unknown> {
  @service intl!: IntlService

  @service store!: Store

  @service flashQueue!: FlashQueueService

  @service router!: RouterService

  @service log!: Log

  @service subscriptionUtilisation!: SubscriptionUtilisationService

  @service subscriptionType!: SubscriptionTypeService

  createTeacherSubTask = task({ drop: true }, async (subscriptionType, teacher) => {
    try {
      await this.store.createRecord<TeacherSubscription>('teacher-subscription', { subscriptionType, teacher }).save()

      await this.subscriptionUtilisation.fetchAll()

      // Refresh the subscription type route, then redirect them to the home page.
      await this.router.refresh('subscription-type')
      await this.router.replaceWith('subscription-type.home')
      this.flashQueue.addSuccess({ subtitle: this.intl.t('pages.accessMissing.flash.createTrialSuccess') })
    } catch (e) {
      this.flashQueue.addFail({ subtitle: this.intl.t('pages.accessMissing.flash.createTrialFail') })
      this.log.error('failed to create trial teacher subscription type for new user', e as LogArgument)
    }
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if (eq this.subscriptionType.current SubscriptionType.Reading)}}
      <PageAccessMissingReading @createTeacherSubTask={{this.createTeacherSubTask}} class="grow" />
    {{else if (eq this.subscriptionType.current SubscriptionType.Maths)}}
      <PageAccessMissingMaths @createTeacherSubTask={{this.createTeacherSubTask}} class="grow" />
    {{else if (eq this.subscriptionType.current SubscriptionType.Writing)}}
      <PageAccessMissingWriting @createTeacherSubTask={{this.createTeacherSubTask}} class="grow" />
    {{/if}}
  </template>
}

export default RouteTemplate(AccessMissing)
